// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.basic-table {
  width: 100%;
  /* border-collapse: separate; */
  font-family: Avenir;
  border-spacing: 0 10px;
}

.basic-header {
  background-color: #f1f3f4;
  margin-bottom: 3px;
  box-sizing: border-box;
}

.basic-table th,
.basic-table td {
  padding: 0 20px;
}

.basic-header th {
  border-bottom: 1px solid #dadcdf;
  height: 34px;
  font-size: 15px;
  color: #54585d;
  font-weight: 900;
  padding: 16px;
}

/* .basic-header th:first-child,
td.basic-cell:first-child {
  border-left: 1px solid #dadcdf;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 0 25px;
}
.basic-header th:last-child,
td.basic-cell:last-child {
  border-right: 1px solid #dadcdf;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
} */

.basic-cell {
  border-top: 1px solid #dadcdf;
  border-bottom: 1px solid #dadcdf;
  height: 60px;
}

.sortable-cell {
  cursor: pointer;
}

.better-cell {
  background-color: #f0ffe1;
}

.better-row {
  color: #ca5030;
}

.clear {
  clear: both;
}

td.ordered-cell {
  background-color: #f6f1f1;
}

th.ordered-cell {
  background-color: #c7c9ca;
  display: flex;
  align-items: center;
}

.input-search {
  /* float: right; */
  /* border-radius: 5px;
  border: 1px solid #dadcdf;
  height: 36px;
  width: 205px;
  padding: 0 10px; */
}

.menu-cell {
  width: 85px;
}
/* .options-menu-button {
  position: relative;
  display: none;
}
.basic-row:hover .options-menu-button {
  display: block;
}
.options-menu {
  display: none;
}
.options-menu-button:hover .options-menu {
  display: block;
} */
.basic-add-new-line-button {
  display: inline-block;
  margin-top: 7px;
}
.basic-row option:disabled {
  background-color: #f8f5f5;
}
/* select.basic-select {
  height: 36px;
  padding: 0 12px;
  padding-right: 20px;
  box-sizing: border-box;
  border: 1px solid #dadcdf;
  color: #54585d;
  font-size: 12px;
  letter-spacing: -0.2px;
  line-height: 16px;
  -moz-appearance: none;
  -webkit-appearance: none;
} */

.rotate-arrow svg {
  transform: rotate(180deg);
}
.header-sort-arrow {
  margin-left: 10px;
}
.table-menu-buttons-container {
  float: right;
}
.table-menu-buttons-container .table-menu-button {
  cursor: pointer;
}
td.user-picture img {
  width: 45px;
  height: 45px;
  border-radius: 30px;
}

td.user-picture {
  border: 1px solid #dadcdf;
  border-right: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
/* 
.contain-select {
  overflow: hidden;
  position: relative;
}

.contain-select:after {
  content: ">";
  position: absolute;
  top: 20px;
  right: 32px;
  z-index: 1;
  pointer-events: none;
  transform: rotate(90deg);
} */
`, "",{"version":3,"sources":["webpack://./../../packages/ui-core/src/components/Table/table.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB;;;;oBAIkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;;;;;;;;;;;;GAYG;AACH;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;GAYG;;AAEH;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;;;;;;;;;;;;;;GAcG","sourcesContent":["table.basic-table {\n  width: 100%;\n  /* border-collapse: separate; */\n  font-family: Avenir;\n  border-spacing: 0 10px;\n}\n\n.basic-header {\n  background-color: #f1f3f4;\n  margin-bottom: 3px;\n  box-sizing: border-box;\n}\n\n.basic-table th,\n.basic-table td {\n  padding: 0 20px;\n}\n\n.basic-header th {\n  border-bottom: 1px solid #dadcdf;\n  height: 34px;\n  font-size: 15px;\n  color: #54585d;\n  font-weight: 900;\n  padding: 16px;\n}\n\n/* .basic-header th:first-child,\ntd.basic-cell:first-child {\n  border-left: 1px solid #dadcdf;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  padding: 0 25px;\n}\n.basic-header th:last-child,\ntd.basic-cell:last-child {\n  border-right: 1px solid #dadcdf;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n} */\n\n.basic-cell {\n  border-top: 1px solid #dadcdf;\n  border-bottom: 1px solid #dadcdf;\n  height: 60px;\n}\n\n.sortable-cell {\n  cursor: pointer;\n}\n\n.better-cell {\n  background-color: #f0ffe1;\n}\n\n.better-row {\n  color: #ca5030;\n}\n\n.clear {\n  clear: both;\n}\n\ntd.ordered-cell {\n  background-color: #f6f1f1;\n}\n\nth.ordered-cell {\n  background-color: #c7c9ca;\n  display: flex;\n  align-items: center;\n}\n\n.input-search {\n  /* float: right; */\n  /* border-radius: 5px;\n  border: 1px solid #dadcdf;\n  height: 36px;\n  width: 205px;\n  padding: 0 10px; */\n}\n\n.menu-cell {\n  width: 85px;\n}\n/* .options-menu-button {\n  position: relative;\n  display: none;\n}\n.basic-row:hover .options-menu-button {\n  display: block;\n}\n.options-menu {\n  display: none;\n}\n.options-menu-button:hover .options-menu {\n  display: block;\n} */\n.basic-add-new-line-button {\n  display: inline-block;\n  margin-top: 7px;\n}\n.basic-row option:disabled {\n  background-color: #f8f5f5;\n}\n/* select.basic-select {\n  height: 36px;\n  padding: 0 12px;\n  padding-right: 20px;\n  box-sizing: border-box;\n  border: 1px solid #dadcdf;\n  color: #54585d;\n  font-size: 12px;\n  letter-spacing: -0.2px;\n  line-height: 16px;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n} */\n\n.rotate-arrow svg {\n  transform: rotate(180deg);\n}\n.header-sort-arrow {\n  margin-left: 10px;\n}\n.table-menu-buttons-container {\n  float: right;\n}\n.table-menu-buttons-container .table-menu-button {\n  cursor: pointer;\n}\ntd.user-picture img {\n  width: 45px;\n  height: 45px;\n  border-radius: 30px;\n}\n\ntd.user-picture {\n  border: 1px solid #dadcdf;\n  border-right: 0;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n/* \n.contain-select {\n  overflow: hidden;\n  position: relative;\n}\n\n.contain-select:after {\n  content: \">\";\n  position: absolute;\n  top: 20px;\n  right: 32px;\n  z-index: 1;\n  pointer-events: none;\n  transform: rotate(90deg);\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
